import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableSurveyor } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ScrollToTop,
} from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Pagination,
  Button,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form, Button as BootstrapButton } from "react-bootstrap";

const TampilSurveyor = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();

  const [isFetchError, setIsFetchError] = useState(false);
  const [isSurveyorExist, setIsSurveyorExist] = useState(false);
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [namaSurveyor, setNamaSurveyor] = useState("");
  const [jenisSurveyor, setJenisSurveyor] = useState("");
  const [teleponSurveyor, setTeleponSurveyor] = useState("");
  const [kodeHeadSurveyor, setKodeHeadSurveyor] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [surveyorsData, setSurveyorsData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    { title: "No", field: "no" },
    { title: "Kode", field: "kodeSurveyor" },
    { title: "Nama Surveyor", field: "namaSurveyor" },
    { title: "Jenis Surveyor", field: "jenisSurveyor" },
    { title: "Telepon Surveyor", field: "teleponSurveyor" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id ? getSurveyorById() : setIsSurveyorExist(false);
  }, [id]);

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI") {
      getSurveyorAll();
    } else {
      getSurveyor();
    }
  }, [page, searchTerm]);

  const getSurveyor = async () => {
    setLoading(true);
    try {
      const allSurveyors = await axios.post(
        `${tempUrl}/surveyorsPagination?search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      setQuery(searchTerm);
      setSurveyorsData(allSurveyors.data.surveyors);
      setPage(allSurveyors.data.page);
      setPages(allSurveyors.data.totalPage);
      setRows(allSurveyors.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSurveyorAll = async () => {
    setLoading(true);
    try {
      const allSurveyors = await axios.post(
        `${tempUrl}/surveyorsAllCabangPagination?search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        }
      );
      setQuery(searchTerm);
      setSurveyorsData(allSurveyors.data.surveyors);
      setPage(allSurveyors.data.page);
      setPages(allSurveyors.data.totalPage);
      setRows(allSurveyors.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSurveyorsForDoc = async (isPdf, isExcel) => {
    setLoading(true);
    const allSurveyorsForDoc = await axios.post(`${tempUrl}/surveyorsForDoc`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setLoading(false);
    if (isPdf) {
      downloadPdf(allSurveyorsForDoc.data);
    } else if (isExcel) {
      downloadExcel(allSurveyorsForDoc.data);
    }
  };

  const getSurveyorsAllCabangForDoc = async (isPdf, isExcel) => {
    setLoading(true);
    const allSurveyorsForDoc = await axios.post(
      `${tempUrl}/surveyorsAllCabangForDoc`,
      {
        id: user._id,
        token: user.token,
      }
    );
    setLoading(false);
    if (isPdf) {
      downloadPdf(allSurveyorsForDoc.data);
    } else if (isExcel) {
      downloadExcel(allSurveyorsForDoc.data);
    }
  };

  const getSurveyorById = async () => {
    setLoading(true);
    if (id) {
      const pickedSurveyor = await axios.post(`${tempUrl}/surveyors/${id}`, {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setIsSurveyorExist(true);
      setKodeSurveyor(pickedSurveyor.data.kodeSurveyor);
      setNamaSurveyor(pickedSurveyor.data.namaSurveyor);
      setJenisSurveyor(pickedSurveyor.data.jenisSurveyor);
      setTeleponSurveyor(pickedSurveyor.data.teleponSurveyor);
      setKodeHeadSurveyor(
        pickedSurveyor.data.kodeHeadSurveyor &&
          `${pickedSurveyor.data.kodeHeadSurveyor.kodeHeadSurveyor} - ${pickedSurveyor.data.kodeHeadSurveyor.namaHeadSurveyor}`
      );
    }
    setLoading(false);
  };

  const deleteSurveyor = async (id) => {
    const findJualsSurveyor = await axios.post(`${tempUrl}/jualsSurveyor`, {
      kodeSurveyor: id,
      id: user._id,
      token: user.token,
    });
    const findRejectSurveyor = await axios.post(`${tempUrl}/rejectsSurveyor`, {
      kodeSurveyor: id,
      id: user._id,
      token: user.token,
    });
    let isSurveyorDataExist =
      findJualsSurveyor.data.length > 0 || findRejectSurveyor.data.length > 0;
    if (isSurveyorDataExist) {
      // There's Record -> Forbid Delete
      handleClickOpen();
    } else {
      // No Record Found -> Delete
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/deleteSurveyor/${id}`, {
          id: user._id,
          token: user.token,
        });
        setKodeSurveyor("");
        setNamaSurveyor("");
        setJenisSurveyor("");
        setTeleponSurveyor("");
        setKodeHeadSurveyor("");
        setLoading(false);
        navigate("/surveyor");
        if (user.tipeUser === "OWN/DIREKSI") {
          getSurveyorAll();
        } else {
          getSurveyor();
        }
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
  };

  const downloadPdf = (data) => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Surveyor`, 90, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.setFontSize(12);
    let no = 0;
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: data.map((col) => {
        no++;
        return { ...col, no };
      }),
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `Surveyor`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarSurveyor.xlsx`);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Master</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Surveyor
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Tidak bisa dihapus karena sudah ada data!`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Nama Surveyor data: ${namaSurveyor}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            startIcon={<PrintIcon />}
            onClick={() => {
              if (user.tipeUser === "OWN/DIREKSI") {
                getSurveyorsAllCabangForDoc(true, false);
              } else {
                getSurveyorsForDoc(true, false);
              }
            }}
          >
            CETAK
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => {
              if (user.tipeUser === "OWN/DIREKSI") {
                getSurveyorsAllCabangForDoc(true, false);
              } else {
                getSurveyorsForDoc(true, false);
              }
            }}
          >
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>
      {isSurveyorExist && (
        <section className="section-panel mt-4">
          <div className="toolbar mt-0">
            <div className="detail-title-actions">
              <BootstrapButton className="btn-back" size="sm" variant="outline-secondary" onClick={() => navigate("/surveyor")}>
                {"< Kembali"}
              </BootstrapButton>
              <div>
                <h2 className="h6 fw-bold mb-1">Detail Surveyor</h2>
                <div className="text-muted">{namaSurveyor}</div>
              </div>
            </div>
          </div>
          <hr />
          <Row>
            <Col lg={6} md={8}>
              <div className="mb-3">
                <div className="detail-label">Kode Surveyor</div>
                <div className="detail-value">{kodeSurveyor || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Nama Surveyor</div>
                <div className="detail-value">{namaSurveyor || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Telepon</div>
                <div className="detail-value">{teleponSurveyor || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Jenis Surveyor</div>
                <div className="detail-value">{jenisSurveyor || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Head Surveyor</div>
                <div className="detail-value">{kodeHeadSurveyor || "-"}</div>
              </div>
            </Col>
          </Row>
        </section>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableSurveyor currentPosts={surveyorsData} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilSurveyor;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
